import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { TokenService } from './token-service';

@Injectable({ providedIn: 'root' })
export class RequireAuthenticatedUser {
  private tokenService = inject(TokenService);
  private router = inject(Router);

  canActivate(): Promise<boolean> {
    return this.tokenService.canActivate().then((ok) => {
      if (!ok) {
        this.tokenService.setRedirectTo(window.location.pathname + window.location.search);
        this.router.navigateByUrl('auth/sign_in');
      }
      return ok;
    });
  }

  canActivateChild(): Promise<boolean> {
    return this.canActivate();
  }
}
